import * as React from "react";
import IMyTradesPage, { IMyTradeTransaction } from "./IMyTradesPage";
import Header from "@appComponents/Header/Header";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import Loader from "@appComponents/Loader/Loader";
import MyTradesList from "@market/components/MyTradesList/MyTradesList";
import CsvGenerator from "@appComponents/CsvGenerator/CsvGenerator";
import { classNames as cn } from "@features/utils/reactFunctions";

import * as style from "./MyTradesPageStyle.module.scss";
import * as general from "@appStyles/general.module.scss";

type TMyTradesPageState = {
  page: number;
  per_page: number;
  trades: IMyTradeTransaction[];
  loader: boolean;
  total_count: number;
  total_pages: number;
};

export default class MyTradesPage extends React.Component<
  IMyTradesPage,
  TMyTradesPageState
> {
  state: TMyTradesPageState = {
    page: 1,
    per_page: 10,
    trades: [],
    loader: true,
    total_count: 0,
    total_pages: 0,
  };

  componentDidMount() {
    SecondaryMarketService.getMyTrades(this.state.page, 5).then((res) => {
      this.setState({ trades: res.data, loader: false });
    });
  }

  render() {
    const { trades, loader } = this.state;
    return (
      <React.Fragment>
        <Header padding={"50 20"}>
          <h1 className={style.title}>My Trades</h1>
        </Header>
        <div className={style.linkContainer}>
          <CsvGenerator
            baseEndpoint="/api/share_service/trades"
            endpointDetails={{}}
            noPagination={true}
            fileName="my-trades"
          />
        </div>
        <div className={cn(general.appContainer, style.tradesContainer)}>
          {!loader && <MyTradesList tradesList={trades} />}
          {loader && (
            <div className={style.loaderContainer}>
              <Loader />
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
